import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = '',
  ...props
}: CTAButtonProps) {
  return <button className={`inline-flex items-center justify-center px-8 py-4 text-base font-medium bg-cta text-white hover:bg-cta-hover transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cta shadow-sm ${className}`} {...props} data-id="element-146">
      {children}
    </button>;
}